var React = require('react');

function Gallery (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M42.4998 40.5L23.3359 25.8667L7.5 39","stroke":"#484848","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M54.5 37L44.5195 31.0333L37 35.5","stroke":"#484848","strokeLinejoin":"round","key":1}),React.createElement("rect",{"x":"6.7002","y":"11.9","width":"48.6","height":"38.2667","stroke":"#484848","key":2}),React.createElement("path",{"d":"M47.0331 21.2166C47.0331 22.9379 45.6378 24.3333 43.9165 24.3333C42.1952 24.3333 40.7998 22.9379 40.7998 21.2166C40.7998 19.4954 42.1952 18.1 43.9165 18.1C45.6378 18.1 47.0331 19.4954 47.0331 21.2166Z","stroke":"#484848","key":3})]);
}

Gallery.defaultProps = {"width":"62","height":"62","viewBox":"0 0 62 62","fill":"none"};

module.exports = Gallery;

Gallery.default = Gallery;
